// CheckoutButton.tsx
import { Card, Heading } from '@here/components'
import { PaymentsPortalButton } from './PaymentsPortalButton'

export default function CheckoutButton() {
  return (
    <Card.Root
      p={4}
      display="grid"
    >
      <Heading>My Subscription</Heading>
      <PaymentsPortalButton />
    </Card.Root>
  )
}
